import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPushPin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.51781 17.6325C11.3589 15.4802 15.424 15.6998 18.0154 18.2912L21.9045 22.1803C24.4959 24.7717 24.7154 28.8367 22.5632 31.6779L8.51781 17.6325Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24.4677,
			y: 6.53554,
			width: 13,
			height: 1,
			rx: .5,
			transform: "rotate(45 24.4677 6.53554)",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 25.2632,
			y1: 8.56847,
			x2: 16.5128,
			y2: 17.3189,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 31.6272,
			y1: 14.9324,
			x2: 22.8767,
			y2: 23.6829,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 15.3189,
			y1: 24.3464,
			x2: 8.51296,
			y2: 31.1523,
			stroke: "currentColor",
			strokeWidth: 2
		})
	]
});
const ForwardRef = forwardRef(SvgPushPin);
export default ForwardRef;
